import React from "react";
import { DriverShell } from "@/components/Shells";
import AccountView from "@/components/AccountView";

export default function DriverAccount() {
  return (
    <DriverShell>
      <AccountView />
    </DriverShell>
  );
}
